import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../useAxios";
import { useTranslation } from "react-i18next";
import { App } from "antd";

export const useResetAllEmailTemplates = () => {
  const axios = useAxios();
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { message } = App.useApp();

  const resetAllEmailTemplates = async () => {
    try {
      const response = await axios.post("/api/emailtemplates/reset-all");
      return response.data;
    } catch (error) {
      throw new Error(t("messages.error.resetAllEmailTemplates"));
    }
  };

  return useMutation({
    mutationFn: resetAllEmailTemplates,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["emailTemplates"] });
      message.success(t("messages.success.resetAllEmailTemplates"));
    },
  });
};